<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Minutas Reuniones</h4>
            <div class="small text-muted">Detalle de la minuta de reunión</div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="arr.report">
          <b-col>
            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.id">
                  <td class="reports-meetings-detail-title-table-custom align-middle">ID</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    <b>{{this.arr.report.id}}</b>
                  </td>
                </tr>
                <tr>
                  <td class="reports-meetings-detail-title-table-custom align-middle">Fecha</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    {{moment(this.arr.report.date).format('DD MMMM YYYY')}}
                  </td>
                </tr>

                <tr v-if="arr.report.title">
                  <td class="reports-meetings-detail-title-table-custom align-middle">Título</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    <b>{{this.arr.report.title}}</b>
                  </td>
                </tr>

                <tr v-if="arr.report.staff_id">
                  <td class="reports-meetings-detail-title-table-custom align-middle">Responsable</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    <b-avatar :src="this.arr.report.staff.image"
                              v-if="this.arr.report.staff.image">
                    </b-avatar>
                    <b-avatar v-else
                              variant="dark">
                    </b-avatar>
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + this.arr.report.staff.name">
                      {{this.arr.report.staff.name}}
                    </b>
                  </td>
                </tr>

                <tr v-if="arr.report.sellers_id">
                  <td class="reports-meetings-detail-title-table-custom align-middle">Vendedor</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    <b-avatar :src="arr.report.seller.staff && arr.report.seller.staff.image ? arr.report.seller.staff.image : null"
                              v-if="arr.report.seller.staff && arr.report.seller.staff.image">
                    </b-avatar>
                    <b-avatar v-else
                              variant="dark">
                    </b-avatar>
                    <b-icon icon="blank"></b-icon>
                    <b>{{this.arr.report.seller.name}}</b>
                  </td>
                </tr>

                <tr v-if="arr.report.zone">
                  <td class="reports-meetings-detail-title-table-custom align-middle">Zona</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    {{this.arr.report.zone.name}}
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-hover table-sm">
              <tbody>
                <tr v-if="arr.report.observations">
                  <td class="reports-meetings-detail-title-table-custom align-middle">Mensaje</td>
                  <td class="reports-meetings-detail-value-table-custom align-middle">
                    {{this.arr.report.observations}}
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'

  export default {
    data: () => {
      return {
        access: {
          module_id: Modules.INFORME_REUNIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'detailReport',
          elements: {}
        },
        reportID: 0,
        arr: {
          report: null
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.reportID = this.$route.params.reportID
      this.load()
    },
    methods: {
      load() {
        var result = serviceAPI.mostrar(this.reportID)

        result.then((response) => {
          var data = response.data
          this.arr.report = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },
    }
  }
</script>
<style>
  .reports-meetings-detail-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 25%;
    text-align: right
  }
  .reports-meetings-detail-value-table-custom {
    padding-left: 5px;
    white-space: pre-line;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
